import { Injectable } from '@angular/core';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Selector, State, Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { IProcessView } from 'src/app/models/process-manager';
import { ProcessQueueStateModel } from './process-manager.state.models';
import { DataAction, Payload, StateRepository } from '@angular-ru/ngxs/decorators';
import { IProcessInstanceItem, IProcessTaskConfig } from './../../models/process-manager';
import { produce } from 'immer';
import { ProcessManagerEndpoint } from './process-manager.endpoint.service';
import { AlertCommand } from '../alert.service';

@StateRepository()
@State<ProcessQueueStateModel>({
  name: 'viewRepositoryState',
  defaults: {
    processViews: [],
    processInstanceAction: null,
    processView: null,
    messages: []
  }
})
@Injectable()
export class ViewRepositoryService extends NgxsDataRepository<ProcessQueueStateModel> {

  processViews$: Subscription;
  lastCheckedOutItem: IProcessInstanceItem;

  constructor(public store: Store, private endpoint: ProcessManagerEndpoint
  ) {
    super();
  }

  @Selector()
  static messages(state: ProcessQueueStateModel) {
    return state.messages;
  }
  
  @Selector()
  static processViews(state: ProcessQueueStateModel) {
    return state.processViews;
  }

  @Selector()
  static view(state: ProcessQueueStateModel) {
    return state.processView;
  }

  public getView(): IProcessView {
    return this.store.selectSnapshot<IProcessView>(ViewRepositoryService.view);
  }

  setCheckedOutItemData(item: IProcessInstanceItem) {
    this.lastCheckedOutItem = item;
  }

  getCheckedOutItemData(): IProcessInstanceItem {
    return this.lastCheckedOutItem;
  }

  @Selector()
  static currentActionConfig(state: ProcessQueueStateModel) {
    return state.processInstanceAction;
  }

  public getCurrentActionConfig() {   
     return this.store.selectSnapshot<IProcessTaskConfig>(ViewRepositoryService.currentActionConfig);   
  }

  /******************Redux Actions******************************/
  @DataAction()
  async getProcessViews(currentRole: string) {
    // refactor to get and set separately. mark as used by the old carousel.          
    return await this.endpoint.getProcessViews(currentRole).toPromise();
  }

  
  @DataAction()
  setProcessViews(@Payload('views') views: IProcessView[]) {
    // Call get and set separately, mark as used by the old carousel.
    this.ctx.setState(produce(this.ctx.getState(), (draft: ProcessQueueStateModel) => {
      draft.processViews = views;
    }));
  } 


  @DataAction()
  setProcessView(@Payload('view') view: IProcessView) {
    this.ctx.setState(produce(this.ctx.getState(), (draft: ProcessQueueStateModel) => {
      draft.processView = view;
    }));
  }

  @DataAction()
  setProcessInstanceAction(@Payload('config') config: IProcessTaskConfig) {
    this.ctx.setState(produce(this.ctx.getState(), (draft: ProcessQueueStateModel) => {
      draft.processInstanceAction = config;
    }));
  }

  @DataAction()
  addMessage(@Payload('message') alert: AlertCommand) {
    this.ctx.setState(produce(this.ctx.getState(), (draft: ProcessQueueStateModel) => {
      const messages = draft.messages || [];
      draft.messages.push(alert);
      draft.messages = messages;
    }));
  }

  @DataAction()
  clearMessages() {
    this.ctx.setState(produce(this.ctx.getState(), (draft: ProcessQueueStateModel) => {
      draft.messages = [];
    }));
  }

}
